import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useEffect, useState } from 'react';
import { Iconfont } from '../../../../components/icon/iconfont';
import classes from './style.module.scss';

export const SearchBar = props => {
    useStyles(classes)
    const {search, intl, questions, history} = props

    const [showClear, setShowClear] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const [searchTips, setSearchTips] = useState([]);

    useEffect(()=>{
        if(questions?.length > 0){
            let list = [];
            questions.forEach(q => {
                list = list.concat(q?.children)
            })
            setSearchTips(list)
        }
    },[questions])

    useEffect(()=>{
        if(props.value == 0){
            setInputValue('');
        }
        if(props.value){
            setInputValue(props.value);
            if(!props.stopSearch){
                props.search(props.value)
            }
        } 
    }, [props.value])

    const inputChange = (e) => {
        setInputValue(e.target.value)
    }

    const clear = () => {
        setInputValue("");
    }

    const relatedSearch = (item) => {
        setInputValue("")
        setTimeout(()=>{
            history.push({pathname: `/user/support/question`, state:{id: item.id, parentId: item.parentId, fromFAQ:true}})
        })
    }

    const filter = (e) => {
        let value = e;
        let reg = new RegExp(''+inputValue+'', "ig")
        let after = e;
        if(inputValue){
            after = value.replace(reg, (e)=>{return'<strong>'+e+"</strong>"})
            if(after.indexOf('<strong>') != -1){
                return after
            }
        } else {
            return after
        }
    }

    return (
        <div className={classes.QuestionInputBox}>
            <div className={classes.InputPositionBox}>
                <input id='textInput' type="text"
                       placeholder={intl.formatMessage({id:'popular_search'})} 
                       onFocus={(e)=>{
                           setShowClear(true)
                        }
                        }
                       onBlur={()=>{
                           setTimeout(()=>{setShowClear(false)},100)}
                        }
                       value={inputValue}
                       onChange={(e)=>inputChange(e)}
                       style={{paddingRight:showClear?'0px':'12px'}}
                       />
                {
                    showClear&&
                    <Iconfont className={classes.ClearIcon} onClick={()=>clear()}>&#xe7c5;</Iconfont>
                }
            </div>
            {/* 搜索按钮 */}
            <div className={classes.InputIconBox} onClick={()=>search(inputValue)}>
                <Iconfont>&#xe61e;</Iconfont>
            </div>
            {/* 搜索提示 */}
            {
                showClear && searchTips.length>0 &&
                <div className={classes.SearchTipsBox}>
                    {
                        searchTips.map((item, index) => (
                            <div key={index} onClick={()=>{relatedSearch(item)}} dangerouslySetInnerHTML={{__html:filter(item?.question)}}></div>
                        ))
                    }
                </div>
            }
        </div>
    )
}